export const SIZE_LABELS = {
  "20GP": "20' GP",
  "40GP": "40' GP",
  "40HC": "40' HC",
  "20RF": "20' Reefer",
  "40RF": "40' Reefer",
  "40HCRF": "40' HC Reefer",
  "20OT": "20' Open Top",
  "40OT": "40' Open Top",
  "20FR": "20' Flat Rack",
  "40FR": "40' Flat Rack",
};

export const DRY_SIZES = ["20GP", "40GP", "40HC"];
export const REEFER_SIZES = ["20RF", "40RF", "40HCRF"];
export const OT_SIZES = ["20OT", "40OT"];
export const FR_SIZES = ["20FR", "40FR"];

export const SIZES_BY_TYPE = { dry: DRY_SIZES, reefer: REEFER_SIZES, ot: OT_SIZES, fr: FR_SIZES };
export const sizesFor = (t) => SIZES_BY_TYPE[t] || DRY_SIZES;
export const CONTAINER_TYPES = [
  { v: "dry", l: "Dry" },
  { v: "reefer", l: "Reefer" },
  { v: "ot", l: "Open Top (OT)" },
  { v: "fr", l: "Flat Rack (FR)" },
];

export const CARGO_TYPES = ["General Cargo", "FMCG", "Hazardous", "Reefer Cargo", "OOG / Special Cargo"];
export const CURRENCIES = ["USD", "INR", "EUR", "GBP", "AED", "SGD", "CNY"];

export const TRADE_LANES = [
  { title: "India → UAE", pol: "Mundra", pod: "Jebel Ali", region: "Middle East", slug: "india-to-dubai" },
  { title: "India → Saudi Arabia", pol: "Nhava Sheva", pod: "Jeddah", region: "Middle East", slug: "india-to-saudi-arabia" },
  { title: "India → Europe", pol: "Mundra", pod: "Rotterdam", region: "Europe", slug: "india-to-europe" },
  { title: "India → USA", pol: "Nhava Sheva", pod: "New York", region: "North America", slug: "india-to-usa" },
  { title: "India → Africa", pol: "Chennai", pod: "Mombasa", region: "Africa", slug: "india-to-africa" },
  { title: "India → Far East", pol: "Chennai", pod: "Singapore", region: "Far East", slug: "india-to-far-east" },
];

export const TRADE_LANE_PAGES = {
  "india-to-dubai": {
    title: "India to Dubai (UAE) Sea Freight Rates",
    heading: "India → Dubai (Jebel Ali) Ocean Freight Rates",
    pol: "Mundra", pod: "Jebel Ali", region: "Middle East",
    metaTitle: "India to Dubai Sea Freight Rates | Mundra to Jebel Ali FCL | VK Forwarders",
    metaDescription: "Compare live India to Dubai ocean freight rates from Mundra & Nhava Sheva to Jebel Ali. FCL 20ft/40ft dry & reefer, shipping-line local charges and transit times. Plan your UAE shipment with VK Forwarders.",
    blurb: "Get up-to-date FCL ocean freight rates from India to Dubai (Jebel Ali). Compare shipping lines side by side, view local charges separately and calculate your total landed shipment cost before you book.",
  },
  "india-to-saudi-arabia": {
    title: "India to Saudi Arabia Sea Freight Rates",
    heading: "India → Saudi Arabia (Jeddah / Dammam) Ocean Freight Rates",
    pol: "Nhava Sheva", pod: "Jeddah", region: "Middle East",
    metaTitle: "India to Saudi Arabia Sea Freight Rates | Jeddah & Dammam FCL | VK Forwarders",
    metaDescription: "Live India to Saudi Arabia ocean freight rates to Jeddah and Dammam. FCL container rates, shipping-line local charges and transit times. Plan and book your Saudi shipment with VK Forwarders.",
    blurb: "Container freight rates from India to Saudi Arabia (Jeddah & Dammam). Compare carriers, see itemised local charges and estimate your total shipment cost.",
  },
  "india-to-europe": {
    title: "India to Europe Sea Freight Rates",
    heading: "India → Europe (Rotterdam / Hamburg) Ocean Freight Rates",
    pol: "Mundra", pod: "Rotterdam", region: "Europe",
    metaTitle: "India to Europe Sea Freight Rates | Rotterdam & Hamburg FCL | VK Forwarders",
    metaDescription: "Compare India to Europe ocean freight rates to Rotterdam, Hamburg and Dublin. FCL 20ft/40ft dry & reefer rates, local charges and transit times with VK Forwarders.",
    blurb: "Ocean freight rates from India to Europe. Compare shipping lines to North Europe ports, view local charges separately and calculate landed cost.",
  },
  "india-to-usa": {
    title: "India to USA Sea Freight Rates",
    heading: "India → USA (New York) Ocean Freight Rates",
    pol: "Nhava Sheva", pod: "New York", region: "North America",
    metaTitle: "India to USA Sea Freight Rates | New York FCL Ocean Freight | VK Forwarders",
    metaDescription: "Live India to USA ocean freight rates to New York and US East Coast. FCL container rates, shipping-line local charges and transit times. Plan your US shipment with VK Forwarders.",
    blurb: "FCL ocean freight rates from India to the USA. Compare carriers to the US East Coast, review local charges and estimate total shipment cost.",
  },
  "india-to-africa": {
    title: "India to Africa Sea Freight Rates",
    heading: "India → Africa (Mombasa) Ocean Freight Rates",
    pol: "Chennai", pod: "Mombasa", region: "Africa",
    metaTitle: "India to Africa Sea Freight Rates | Mombasa FCL Ocean Freight | VK Forwarders",
    metaDescription: "Compare India to Africa ocean freight rates to Mombasa and East Africa. FCL dry & reefer container rates, local charges and transit times with VK Forwarders.",
    blurb: "Container freight rates from India to Africa. Compare shipping lines to East African ports and calculate your total shipment cost.",
  },
  "india-to-far-east": {
    title: "India to Far East Sea Freight Rates",
    heading: "India → Far East (Singapore / Shanghai) Ocean Freight Rates",
    pol: "Chennai", pod: "Singapore", region: "Far East",
    metaTitle: "India to Far East Sea Freight Rates | Singapore & Shanghai FCL | VK Forwarders",
    metaDescription: "Live India to Far East ocean freight rates to Singapore and Shanghai. FCL container rates, shipping-line local charges and transit times. Plan your shipment with VK Forwarders.",
    blurb: "Ocean freight rates from India to the Far East. Compare carriers to Singapore and Shanghai, review local charges and estimate landed cost.",
  },
};

export const fmtNum = (n) =>
  n === null || n === undefined || isNaN(n)
    ? "-"
    : Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 });

export const WHATSAPP_NUMBER = "919122093078";
export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
export const waRateMessage = (r) =>
  `Hi VK Forwarders, I'm interested in this ${r.shipment_type} rate:\n` +
  `${r.pol_name} → ${r.pod_name}\n` +
  `Line: ${r.shipping_line_name}\n` +
  `Container: ${r.size_label || r.container_size} (${r.container_type})\n` +
  `Please share your best quote and availability.`;

export const fmtMoney = (n, cur = "") =>
  `${cur ? cur + " " : ""}${fmtNum(n)}`;
